import {
	AI_PRIVACY_POLICY_SECTION,
	AI_PRIVACY_POLICY_SECTION_MARKER,
} from '../content/aiPrivacyPolicySection';

const PRIVACY_POLICY_SLUG = 'politica-de-privacidade';

export function enrichPrivacyPolicyText(text) {
	if (!text) {
		return AI_PRIVACY_POLICY_SECTION;
	}

	if (text.includes(AI_PRIVACY_POLICY_SECTION_MARKER)) {
		return text;
	}

	return `${text}${AI_PRIVACY_POLICY_SECTION}`;
}

export async function fetchPrivacyPolicy(http) {
	const { data } = await http.get(
		`items/termos/?filter[slug][_eq]=${PRIVACY_POLICY_SLUG}&filter[status][_eq]=published`
	);
	const termo = data.data && data.data[0];

	if (!termo) {
		return {
			titulo: 'Política de Privacidade',
			texto: AI_PRIVACY_POLICY_SECTION,
		};
	}

	return {
		...termo,
		texto: enrichPrivacyPolicyText(termo.texto),
	};
}
